__webpack_require__.p = "https://verify.getverdict.com/";